/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonValidatorAddressSummaryInfo } from './BabylonValidatorAddressSummaryInfo';

export type BabylonProposalVoteValidatorInfo = {
    VD: BabylonValidatorAddressSummaryInfo;
    VTP: BabylonProposalVoteValidatorInfo.VTP;
    VP: string;
    VPVAL: string;
    VPP: string;
    VTRXHASH: string;
    AGE: string;
    UT: number;
};

export namespace BabylonProposalVoteValidatorInfo {

    export enum VTP {
        YES = 'YES',
        NO = 'NO',
        VETO = 'VETO',
        ABSTAIN = 'ABSTAIN',
        DID_NOT_VOTE = 'DID_NOT_VOTE',
        WEIGHTED = 'WEIGHTED',
    }


}

